/**
 * Card gallery arrows: force theme’s arrowsSlideIn off so CSS left/right control slide direction.
 * Slide is done in CSS (left/right), not transform, so theme keyframes cannot override.
 */
(function () {
  function getArrows(container) {
    const arrows = container.querySelector('slideshow-arrows');
    if (!arrows) return null;
    const prev = arrows.querySelector('[ref="previous"]') || arrows.querySelector('.slideshow-control--previous');
    const next = arrows.querySelector('[ref="next"]') || arrows.querySelector('.slideshow-control--next');
    return prev && next ? { prev, next } : null;
  }

  function applyStyles(prev, next) {
    [prev, next].forEach(function (el) {
      el.style.setProperty('animation', 'none', 'important');
      el.style.setProperty('transform', 'none', 'important');
    });
  }

  const INITED_ATTR = 'data-card-arrows-inited';

  function initCard(card, forceHidden) {
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    const arrows = getArrows(gallery);
    if (!arrows) return;
    if (!forceHidden && gallery.hasAttribute(INITED_ATTR)) return;
    gallery.setAttribute(INITED_ATTR, 'true');
    applyStyles(arrows.prev, arrows.next);
  }

  function init(forceHidden) {
    const cards = document.querySelectorAll('.product-card, product-card');
    cards.forEach(function (card) {
      return initCard(card, forceHidden);
    });
  }

  let inited = false;
  function ensureInited() {
    if (inited) return;
    inited = true;
    init();
  }

  function onMouseOver(e) {
    const card = e.target.closest && (e.target.closest('.product-card') || e.target.closest('product-card'));
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    ensureInited();
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    const arrows = getArrows(gallery);
    if (arrows) applyStyles(arrows.prev, arrows.next);
  }

  function onMouseOut(e) {
    const card = e.target.closest && (e.target.closest('.product-card') || e.target.closest('product-card'));
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    const arrows = getArrows(gallery);
    if (arrows) applyStyles(arrows.prev, arrows.next);
  }

  document.body.addEventListener('mouseover', onMouseOver, true);
  document.body.addEventListener('mouseout', onMouseOut, true);

  function run() {
    init(true);
    /* Re-apply a few times so we win over any theme animation that applies on first paint/hover */
    var frame = 0;
    function reinit() {
      init(true);
      if (frame < 5) {
        frame++;
        requestAnimationFrame(reinit);
      }
    }
    requestAnimationFrame(reinit);
    document.addEventListener('shopify:section:load', function () {
      inited = false;
      init(true);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(true);
      });
    }
    window.addEventListener('load', function () {
      init(true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
